import { CommonModule } from '@angular/common';
import { Component, inject, Inject, OnInit, signal } from '@angular/core';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { Observable, map, of } from 'rxjs';
import { LogEventsEnum } from 'src/app/firebase.model';
import { PriceTypePipe } from 'src/app/pipes/price-type.pipe';
import { LotsService } from 'src/app/services/lots.service';

export interface NewLotSummaryDialog {
  form: any;
}

@Component({
  selector: 'app-new-lot-summary-dialog',
  imports: [MatDialogModule, CommonModule, MatButtonModule, PriceTypePipe],
  templateUrl: './new-lot-summary-dialog.component.html',
  styleUrl: './new-lot-summary-dialog.component.css',
})
export class NewLotSummaryDialogComponent implements OnInit {
  private analytics = inject(Analytics);
  formValues$: Observable<any>;
  constructor(
    public dialogRef: MatDialogRef<NewLotSummaryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NewLotSummaryDialog,
    readonly lotsService: LotsService
  ) {}
  ngOnInit(): void {
    logEvent(this.analytics, LogEventsEnum.lots_summary_view);
    this.formValues$ = of(this.data).pipe(
      map(() => {
        const formValues = this.data['formValues'];
        console.log('values', formValues)
        return {
          ...formValues,
          visibleSpecs: (formValues?.specifications ?? []).filter(
            (spec) =>
              spec?.value !== null &&
              spec?.value !== undefined &&
              spec?.value !== ''
          ),
        };
      })
    );
  }
}
